"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const is_object_1 = tslib_1.__importDefault(require("./is-object"));
const recursive_error_1 = tslib_1.__importDefault(require("./recursive-error"));
/**
 * @category High Order Guard
 * @return a `Guard` that checks if the value respect the structure described by the guard object passed
 * @throws {RecursiveError} When calling the `self` guard in the callback
 * @example
 * ```typescript
 *   const isPerson = ObjectOf({
 *     firstName: isString,
 *     lastName: isString,
 *     age: isNumber,
 *   });
 * ```
 * @example
 * ```typescript
 *   type Person = {
 *     firstName: string;
 *     lastName: string;
 *     age: number;
 *     spouse: Person | null;
 *   };
 *
 *   const isPerson = ObjectOf<Person>((self) => ({
 *     firstName: isString,
 *     lastName: isString,
 *      age: isNumber,
 *      spouse: OneOf([self, isNull]),
 *   }));
 * ```
 */
const ObjectOf = (guards) => {
    const isObjectOf = (obj) => (0, is_object_1.default)(obj) &&
        Object.entries(generatedGuards).every(([key, guard]) => guard.optional
            ? obj[key] === undefined || guard(obj[key])
            : key in obj && guard(obj[key]));
    const generatedGuards = recursive_error_1.default.assert((forbidCall) => typeof guards === "function" ? guards(forbidCall(isObjectOf)) : guards);
    return isObjectOf;
};
exports.default = ObjectOf;
